<template>
  <div class="footer">
    <div class="footer-top">
      <div class="contact-us">
        <div style="color: #FFFFFF;font-size: 0.25rem"><img style="width: 1rem" src="../../assets/image/index/logo.png"></div>
        <div
          style="font-size: 0.16rem;font-family: PingFang SC;font-weight: 500;line-height: 0.22rem;color: #FFFFFF;margin-top: 0.37rem">
          联系我们
        </div>
        <div
          style="font-size: 0.12rem;font-family: PingFang SC;font-weight: 400;line-height: 0.17rem;color: #FFFFFF;opacity: 0.8;margin-top: 0.19rem">
          <img class="footer-icon" src="../../assets/image/footer-tel.png">服务热线
        </div>
        <div
          style="font-size: 0.18rem;font-family: DIN Alternate;font-weight: bold;line-height: 0.21rem;color: #FFFFFF;opacity: 1;margin-top: 0.09rem">
          18617131848
        </div>
        <div
          style="font-size: 0.12rem;font-family: PingFang SC;font-weight: 400;line-height: 0.17rem;color: #FFFFFF;opacity: 0.8;margin-top: 0.37rem">
          <img class="footer-icon" src="../../assets/image/footer-email.png">电子邮箱
        </div>
        <div
          style="font-size: 0.18rem;font-family: DIN Alternate;font-weight: bold;line-height: 0.21rem;color: #FFFFFF;opacity: 1;margin-top: 0.08rem">
          info@magicwifi.com.cn
        </div>
        <div
          style="font-size: 0.12rem;font-family: PingFang SC;font-weight: 400;line-height: 0.17rem;color: #FFFFFF;opacity: 0.8;margin-top: 0.2rem">
          <img class="footer-icon" src="../../assets/image/footer-address.png">地址：深圳市南山区科技园南长虹科技大厦2105
        </div>
      </div>
      <div class="footer-item-list">
        <div class="footer-item">
          <div  class="footer-item-title">关于我们</div>
          <div @click="jump('about')" class="footer-item-con">公司介绍</div>
          <div @click="jump('contact')" class="footer-item-con">联系我们</div>
          <div @click="jump('talent')" class="footer-item-con">人才招聘</div>
        </div>
        <div class="footer-item">
          <div class="footer-item-title">解决方案</div>
          <div class="footer-item-con">高校无线网络</div>
          <div class="footer-item-con">中职无线网络</div>
          <div class="footer-item-con">工厂无线网络</div>
          <div class="footer-item-con">工地无线网络</div>
          <div class="footer-item-con">校园一脸通</div>
        </div>
        <div class="footer-item">
          <div class="footer-item-title">产品中心</div>
          <div class="footer-item-con">网关</div>
          <div class="footer-item-con">交换机</div>
          <div class="footer-item-con">AP</div>
          <div class="footer-item-con">认证计费系统</div>
          <div class="footer-item-con">网管系统</div>
        </div>
        <div class="footer-item" style="margin-left: -0.4rem">
          <div class="footer-item-title" style="visibility: hidden">产品中心</div>
          <div class="footer-item-con">运维工单</div>
          <div class="footer-item-con">客服系统</div>
          <div class="footer-item-con">审计系统</div>
          <div class="footer-item-con">上网管控</div>
          <div class="footer-item-con">运营中台</div>

        </div>
        <div class="footer-item">
          <div  class="footer-item-title">新闻动态</div>
          <div @click="jump('news',{type:1})" class="footer-item-con">展会风采</div>
          <div @click="jump('news',{type:2})"  class="footer-item-con">项目拓展</div>
          <div @click="jump('news',{type:3})" class="footer-item-con">lemon动态</div>
          <div @click="jump('news',{type:4})" class="footer-item-con">其他</div>
        </div>
      </div>
      <div class="footer-item-public">
        <img class="footer-item-public-img" src="@/assets/image/index/wx-public.jpg">
        <div class="footer-item-public-text">扫码联系我们</div>
      </div>
    </div>
    <div style="margin-top: 0.63rem;border-top:0.01rem solid #666666;height: 0.01rem;width: 100%;"></div>
    <div class="footer-ba" style="display: flex;align-items: center;justify-content: center;">
      <div>Copyright © 2005-2020 lemonwifi.cn 深圳市网联天下科技有限公司版权所有</div>
      <img src="../../assets/image/beian.png" style="width: 0.13rem;height: 0.14rem;margin: 0 0.05rem">
      <div>备案号：粤ICP备 14021249号</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  methods:{
    jump(url,query){
      if(url==='news'){
        this.$router.push({
          name: url,
          query
        });
      }else {
        this.$router.push({
          name: url,
        });
      }

    }
  }
}
</script>

<style scoped>
.footer {
  background: #333333;
  padding: 1rem 1.8rem 1.75rem 1.8rem;
}
.footer-icon{
  width: 0.1rem;
  height: 0.1rem;
  margin-right: 0.04rem;
}
.footer-top{
  display: flex;
  justify-content: space-between;
}

.contact-us {
  padding-right: 1.2rem;
  padding-bottom: 0.25rem;
  border-right: 0.01rem solid #666666;;
}
.footer-item-list{
  display: flex;
  justify-content: space-between;
  padding:0.25rem 2.2rem 0 1.2rem;
  flex: 1;
}
.footer-item{
}

.footer-item-title {
  font-size: 0.16rem;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 0.22rem;
  color: #FFFFFF;
  opacity: 1;
}

.footer-item-con {
  margin-top: 0.22rem;
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 0.2rem;
  color: #FFFFFF;
  opacity: 0.8;
  cursor: pointer;
}
.footer-item-public{
  padding-top: 0.25rem;
  display: flex;
  /*justify-content: center;*/
  align-items: center;
  flex-direction: column;
}

.footer-item-public-img {
  width: 1.2rem;
  height: 1.2rem;
  margin-bottom: 0.11rem;
}

.footer-item-public-text {
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 0.20rem;
  color: #FFFFFF;
  opacity: 0.8;
}

.footer-ba {
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 0.2rem;
  color: #FFFFFF;
  opacity: 0.8;
  margin-top: 0.68rem;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue